import React from "react"
import { BrindesResgatadosFornecedorContextProvider } from "./context/BrindesResgatadosFornecedorContextProvider"
import { BrindesResgatadosFornecedor } from "./BrindesResgatadosFornecedor"

export function Index() {
    return (
        <BrindesResgatadosFornecedorContextProvider>
            <BrindesResgatadosFornecedor />
        </BrindesResgatadosFornecedorContextProvider>
    )
}
